<template>
   <!-- Message from Customer start -->

    <!-- fbcomment  || externallinkopened -->
    <div v-if="attachmentType === 'text' && (['fbcomment', 'externallinkopened'].includes(templateType))" class="messageTemplateContainer">
      <div class="normalchat_component msg_component customer_reply">
        <div>
          <span class="badge-light">{{ badgeText }}</span>
        </div>
        <div v-html="renderNormalChat(message.message)"></div>
        <messageDatetime :dateTimeMessage="message" :userMessage="true" :isSimpleText="true"/>
      </div>
    </div>

    <!-- non-reply to message -->
    <div v-else-if="((!message?.replytomessage || ['', 'None'].includes(message?.replytomessage)) && ( ['document', 'image', 'sticker', 'video', 'unsupported', 'file', 'contact', 'contacts'].includes(attachmentType) || ( attachmentType === 'text' && !['fbcomment', 'externallinkopened'].includes(templateType) ) ) )" class="messageTemplateContainer">
      <!-- text -->
      <div v-if="(attachmentType === 'text' && !['fbcomment', 'externallinkopened'].includes(templateType))" class="normalchat_component msg_component customer_reply">
        <div v-html="renderNormalChat(message.message)"></div>
        <messageDatetime :dateTimeMessage="message" :userMessage="true" :isSimpleText="true"/>
      </div>

      <!-- document and image with preview -->
      <div v-else-if="['document', 'file', 'image', 'sticker'].includes(attachmentType)">
        <AttachmentPreview :message="message" />
        <messageDatetime :dateTimeMessage="message" :userMessage="true" />
      </div>

      <!-- video -->
      <div v-else-if="attachmentType === 'video'">
        <AttachmentPreview :message="message" />
        <messageDatetime :dateTimeMessage="message" :userMessage="true" />
      </div>

      <!-- Contact File -->
      <div v-else-if="attachmentType === 'contact' || attachmentType === 'contacts'" class="normalchat_component msg_component customer_reply">
        <template v-if="isUrl(attachment)">
          <p class="ion-no-margin"><b>Contact text file:</b></p>
          <a :href="sanitizeHardLinkUrl(attachment)" target="_blank" class="openDocument" rel="noreferer noopener">Click here to open file in new window</a>
        </template>
        <template v-else>
          <p class="ion-no-margin"><b>Name: {{ attachmentName }}</b></p>
          <p class="ion-no-margin"><b>Phone number: {{ attachment }}</b></p>
        </template>
        <div>
          <messageDatetime :dateTimeMessage="message" :userMessage="true" :isSimpleText="true" />
        </div>
      </div>
      
      <!-- unsupported -->
      <div v-else-if="attachmentType === 'unsupported'" class="normalchat_component msg_component customer_reply">
        <p>This message is not supported!</p>
        <messageDatetime :dateTimeMessage="message" :userMessage="true" :isSimpleText="true"/>
      </div>
    </div>

    <!-- reply to message -->
    <div v-else-if="message?.replytomessage && message.replytomessage !== 'None'" class="messageTemplateContainer replytomessage_container">
      <div class="innerDiv">
        <!-- text, document, image & video -->
        <div v-if="['text', 'document', 'image', 'video', 'location'].includes(attachmentType)">
          <attachmentComponent :message="message" :activeCustomer="activeCustomer" />
        </div>
      </div>
      <messageDatetime :dateTimeMessage="message" :userMessage="true" />
    </div>

    <!-- map location -->
    <div v-else-if="attachmentType === 'location'" class="messageTemplateContainer">
      <div class="normalchat_component msg_component customer_reply" style="padding: 0px; font-size: 0px;" >
        <iframe :src="getLatLongFromTheGoogleMapsUrl(attachment)" class="mapContainer" allowfullscreen="" loading="lazy" ></iframe>
      </div>
      <messageDatetime :dateTimeMessage="message" :userMessage="true" />
    </div>

    <!-- note -->
    <div v-else-if="templateType === 'note'" class="messageTemplateContainer botMsgBubble">
      <div class="normalchat_component msg_component noteMessageType">
        <p v-if="message.agent" class="anchor_text ion-no-margin paddingBottom">{{ message.agent.name }} left an internal note</p>
        <template v-if="jsonMessage">
          <div v-if="jsonMessage.request">
            <div class="label">Request:</div>
            <pre>{{ jsonMessage.request }}</pre>
          </div>
          <div v-if="jsonMessage.response">
            <div class="label">Response:</div>
            <pre>{{ jsonMessage.response }}</pre>
          </div>
        </template>
        <div v-else v-html="renderNormalChat(message.message)"></div>
        <messageDatetime :dateTimeMessage="message" :userMessage="false" />
      </div>
    </div>

    <!-- status -->
    <div v-else-if="templateType === 'status' && message.message && message.message !== 'None'" class="messageTemplateContainer statusMsgBubble statusMessageType">
      <div class="normalchat_component msg_component statusInfo">
        <p class="status-title ion-no-margin paddingBottom">Status info. message</p>
        <div v-html="renderNormalChat(message?.message)"></div>
        <messageDatetime :dateTimeMessage="message" :userMessage="true" />
      </div>
    </div>

    <!-- schedule -->
    <div v-else-if="templateType === 'schedule'" class="messageTemplateContainer botMsgBubble">
      <div class="normalchat_component msg_component customer_reply scheduleMessageType">
        <div class="reminderIcon">
          <img src="@/resources/images/set-reminder.svg">
        </div>
        <p class="sub-header textDecoration">                          
          Reminder for {{ message.agent.name }}
          <br v-if="message.schedule" />
          <span v-if="message.schedule" style="display: inline-block;"> on {{ message.schedule }} </span>
        </p>
        <div v-if="checkIfMessageNeedsBindHtml(message.message)" v-html="renderNormalChat(message.message)" class="sub-header"></div>
        <div v-else v-html="genericSanitizeHtml(message.message)" class="sub-header"></div>
      </div>
      <messageDatetime :dateTimeMessage="message" :userMessage="false" />
    </div>
    <!-- audio -->
    <div v-else-if="attachmentType === 'audio'" class="messageTemplateContainer">
      <div class="audio_component customer_reply">
        <audio class="audioInChat" controls controlslist="nodownload" >
          <source :src="sanitizeHardLinkUrl(attachment)" type="audio/mpeg" >
        </audio>
      </div>
      <messageDatetime :dateTimeMessage="message" :userMessage="true" />
    </div>

    <!-- Message from customer end -->

    <!-- Reply to customer start -->

    <!-- Text -->
    <div v-if="resultText?.type === 'text'" class="messageTemplateContainer botMsgBubble">
      <div class="normalchat_component msg_component">
        <messageSourceArea :sourceMessage="messageOrigin"  />
        <div v-html="renderNormalChat(resultText.message)"></div>
        <messageDatetime :dateTimeMessage="messageOrigin" />
      </div>
    </div>

    <!-- Contact -->
    <div v-else-if="resultText?.type === 'contact'" class="messageTemplateContainer botMsgBubble">
      <div class="normalchat_component msg_component">
        <messageSourceArea :sourceMessage="messageOrigin" />
        <div class="contact-item">
          <div class="contact-avatar">
            <img :src="checkIfThereIsNoLogoThenShowTransparentImage(activeCustomer.image)" alt="none">
          </div>
          <div class="contact-info">
            <h2>{{ resultText?.name }}</h2>
            <p>{{ resultText?.phone }}</p>
          </div>
        </div>
        <messageDatetime :dateTimeMessage="messageOrigin" />
      </div>
    </div>

    <!-- Location -->
    <div v-else-if="resultText?.type === 'location'" class="messageTemplateContainer botMsgBubble">
      <div class="normalchat_component msg_component">
        <messageSourceArea :sourceMessage="messageOrigin" />
        <div>
          <VIcon name="pin-line"></VIcon>
          <span v-html="renderNormalChat(resultText.message)"></span>
        </div>
        <messageDatetime :dateTimeMessage="messageOrigin" />
      </div>
    </div>

    <!-- Image -->
    <div v-else-if="resultText?.type === 'image' || (resultText?.type === 'file' && resultText?.filetype === 'image')" class="messageTemplateContainer botMsgBubble">
      <div style="text-align: right;">
        <messageSourceArea :sourceMessage="messageOrigin"  />
      </div>
      <AttachmentPreview :url="checkIfThereIsNoLogoThenShowTransparentImage(resultText.message)" fileType="image" />
      <messageDatetime :dateTimeMessage="messageOrigin" />
    </div>

    <!-- Video -->
    <div v-else-if="resultText?.type === 'video' || (resultText?.type === 'file' && resultText?.filetype === 'video')" class="messageTemplateContainer botMsgBubble">
      <div style="text-align: right;">
        <messageSourceArea :sourceMessage="messageOrigin"  />
      </div>
      <AttachmentPreview :url="sanitizeHardLinkUrl(resultText.message)" fileType="video" />
      <messageDatetime :dateTimeMessage="messageOrigin" />
    </div>

    <!-- Document -->
    <div v-else-if="resultText?.type === 'file' && (!resultText?.filetype || resultText?.filetype === 'document')" class="messageTemplateContainer botMsgBubble">
      <messageSourceArea :sourceMessage="messageOrigin"  />
      <AttachmentPreview :url="sanitizeHardLinkUrl(resultText.message)" fileType="document" :fileName="extractFileName(resultText.message)" />
      <messageDatetime :dateTimeMessage="messageOrigin" />
    </div>

    <!-- quick_replies -->
    <div v-else-if="['quick_replies', 'payment_replies'].includes(resultText?.type)" class="messageTemplateContainer botMsgBubble">
      <div v-if="resultText.message" class="normalchat_component msg_component">
        <messageSourceArea :sourceMessage="messageOrigin" />
        <div class="messageArea" v-html="renderNormalChat(resultText.message)"></div>
      </div>
      <div class="quickRepliesArea flex-center gap10P">
        <div v-for="(button, index) in resultText.buttons.filter(btn => Object.keys(btn).length)" :key="index" class="singleQuickReply">
          {{ button.title || button.type || 'Button' }}
        </div>
      </div>
      <messageDatetime :dateTimeMessage="messageOrigin" />
    </div>

    <!-- Button Message -->
    <div v-else-if="resultText?.type == 'button_message' || (resultText?.type == 'payment' && resultText?.buttons)" class="messageTemplateContainer botMsgBubble">
      <div class="buttonMessage_component msg_component">
        <div style="margin-left: 10px">
          <messageSourceArea :sourceMessage="messageOrigin"  />
        </div>
        <div class="media-header ion-no-margin" v-if="resultText?.header_text">
          {{ resultText?.header_text }}
        </div>
        <div v-else class="image-wrapper" :class="{ 'document-wrapper' : checkExtraInfoProperties(resultText?.extrainfo?.media_type) === 'document'}">
          <template v-if="checkExtraInfoProperties(resultText?.extrainfo?.media_type) === 'video'">
            <video :src="resultText.image_url" controls preload="metadata" class="width100P" />
          </template>
          <template v-else-if="checkExtraInfoProperties(resultText?.extrainfo?.media_type) === 'document'">
            <div class="document-preview">
              <img src="@/resources/images/document_outline.svg" class="document-img">
              <div>
                <a :href="resultText.image_url" target="_blank" download class="download-link">{{extractFileName(resultText.image_url)}}</a>
              </div>
            </div>
          </template>
          <template v-else-if="checkExtraInfoProperties(resultText?.extrainfo?.media_type) === 'image'">
            <img :src="checkIfThereIsNoLogoThenShowTransparentImage(resultText.image_url)" alt="" />
          </template>
        </div>
        <div class="text-container">
          <p class="messageArea title ion-no-margin" v-html="renderNormalChat(resultText.message)"></p>
        </div>
        <div class="flex-between footerPadding">
          <p v-if="resultText?.footer_text" class="messageArea sub-title ion-no-margin">{{ resultText?.footer_text }}</p>
          <div :class="{ 'ml-auto': !resultText?.footer_text }">
            <messageDatetime :dateTimeMessage="messageOrigin" />
          </div>
        </div>
        <div class="buttonsArea">
          <button v-for="button in resultText.buttons" :key="button.title" type="button" class="singleCardBigButton">{{ button.title }}</button>
        </div>
      </div>
    </div>

     <!-- genric Header Message -->
    <div v-else-if="resultText?.type == 'generic_message_template'" class="messageTemplateContainer botMsgBubble">
      <div class="buttonMessage_component msg_component">
        <div style="margin-left: 10px">
          <messageSourceArea :sourceMessage="messageOrigin"  />
        </div>
        <div class="media-header ion-no-margin" v-if="resultText?.header_text">
          {{ resultText?.header_text }}
        </div>
        <div v-else class="image-wrapper" :class="{ 'document-wrapper' : checkExtraInfoProperties(resultText?.extrainfo?.media_type) === 'document'}">
          <template v-if="checkExtraInfoProperties(resultText?.extrainfo?.media_type) === 'video'">
            <video :src="resultText.image_url" controls preload="metadata" class="width100P" />
          </template>
          <template v-else-if="checkExtraInfoProperties(resultText?.extrainfo?.media_type) === 'document'">
            <div class="document-preview">
              <img src="@/resources/images/document_outline.svg" class="document-img" alt="document">
              <div>
                <a :href="resultText.image_url" target="_blank" download class="download-link">{{extractFileName(resultText.image_url)}}</a>
              </div>
            </div>
          </template>
          <template v-else-if="checkExtraInfoProperties(resultText?.extrainfo?.media_type) === 'image'">
            <img :src="checkIfThereIsNoLogoThenShowTransparentImage(resultText.image_url)" alt="" />
          </template>
        </div>
        <div v-if="resultText?.content" class="text-container">
          <p class="messageArea title ion-no-margin" v-html="renderNormalChat(resultText.content)"></p>
        </div>
        <div class="flex-between footerPadding">
          <p v-if="resultText?.footer_text" class="messageArea sub-title ion-no-margin">{{ resultText?.footer_text }}</p>
          <div :class="{ 'ml-auto': !resultText?.footer_text }">
            <messageDatetime :dateTimeMessage="messageOrigin" />
          </div>
        </div>
      </div>
    </div>

    <!-- generic Message -->
    <div v-else-if="resultText?.type == 'generic_message' || (resultText?.type == 'payment' && !resultText?.buttons)" class="messageTemplateContainer botMsgBubble">
      <messageSourceArea :sourceMessage="messageOrigin"  />
      <div v-if="resultText?.content"> <!-- whatsapp template body -->
        <div class="normalchat_component msg_component">
          <div v-html="renderNormalChat(resultText.content)"></div>
        </div>
      </div>
      <div class="carousel-container">
        <div class="carousel-spacer"></div>
        <div v-for="carousel in resultText.message" :key="carousel.title" class="carousel-card" :class="{'single-carousel' : resultText.message.length == 1}">
          <template v-if="checkExtraInfoProperties(carousel?.extrainfo?.card_orientation) === 'horizontal'">
            <div class="rcs-rich-card" :class="checkExtraInfoProperties(carousel?.extrainfo?.thumbnail_alignment) === 'right' ? 'rightRichCard' : ''">
              <div class="card">
                <div v-if="carousel.image_url" class="card-image">
                  <img v-if="checkExtraInfoProperties(carousel?.extrainfo?.media_type) === 'image'" :src="checkIfThereIsNoLogoThenShowTransparentImage(carousel.image_url)" alt="" />
                  <video v-else-if="checkExtraInfoProperties(carousel?.extrainfo?.media_type) === 'video'" :src="carousel.image_url" controls preload="metadata" class="width100P" /> 
                </div>
                <div class="rcs-card-content">
                  <div class="content-wrapper text-left">
                    <div>
                      <p class="headerTitle ion-no-margin ion-no-margin">{{ carousel.title }}</p>
                    </div>
                    <div class="description">
                      <p class="sub-title width100P ion-no-margin" :title="carousel.subtitle"  v-html="renderNormalChat(carousel.subtitle)"></p>
                    </div>
                  </div>
                  <div class="button-container">
                    <template v-for="button in carousel.buttons" :key="button.title">
                      <a v-if="isValidButton(button)" class="richCardButton">
                        <p class="title ion-no-margin">{{ button.title }}</p>
                      </a>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="card-content">
              <div class="image-wrapper" v-if="carousel.image_url">
                <video v-if="checkExtraInfoProperties(carousel?.extrainfo?.media_type) === 'video'":src="carousel.image_url" controls preload="metadata" class="width100P" /> 
                <img v-else :src="checkIfThereIsNoLogoThenShowTransparentImage(carousel.image_url)" alt="" />
              </div>
              <div class="text-container">
                <p class="headerTitle ion-no-margin">{{ carousel.title }}</p>
                <div class="description">
                  <p class="sub-title ion-no-margin" :title="carousel.subtitle" v-html="renderNormalChat(carousel.subtitle)" ></p>
                </div>
              </div>
            </div>
            <div class="buttons">
              <template v-for="button in carousel.buttons" :key="button.title">
                <p v-if="isValidButton(button)" class="title ion-no-margin"> {{ button.title }} </p>
              </template>
            </div>
          </template>
        </div>
      </div>
      <messageDatetime :dateTimeMessage="messageOrigin" />
    </div>
</template>
<script>


import { getVideoMimeType, isBrowserPlayableVideoUrl } from '@/helpers/video.helpers';
import attachmentComponent from "./attachmentComponent.vue";
import { sanitizeHardLinkUrl, getLatLongFromTheGoogleMapsUrl } from '@/helpers/message.helpers';
import { renderNormalChat, genericSanitizeHtml } from '@/helpers/text.helpers';
import { checkIfThereIsNoLogoThenShowTransparentImage } from '@/helpers/image.helpers';
import messageSourceArea from "./message-source-area.vue";
import messageDatetime from "./message-datetime.vue";
import HelpTooltip from "@/components/HelpTooltip.vue";
import VideoFallback from "@/components/VideoFallback.vue";
import AttachmentPreview from "@/components/AttachmentPreview.vue";
import { useAuthStore } from '@/stores/auth';


export default {
  mixins: [],
  props: {
    resultText: {
      type: [Object, String],
      default: () => {
        return {};
      },
    },
    activeCustomer: {
      type: Object,
      default: () => {
        return {};
      },
    },
    messageOrigin: {
      type: Object,
      default: () => {
        return {};
      },
    },
    message: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
    };
  },
  components: {
    attachmentComponent,
    messageSourceArea,
    messageDatetime,
    HelpTooltip,
    VideoFallback,
    AttachmentPreview,
  },
  computed: {
    user() { return useAuthStore().cleanUserData; },
    attachment() {
      return this.message?.template?.attachment;
    },
    attachmentName() {
      return this.message?.template?.attachmentname;
    },
    attachmentType() {
      return this.message?.template?.attachmenttype;
    },
    templateType() {
      return this.message?.template?.type || this.message?.template;
    },
    badgeText() {
      if(this.attachmentType == 'text') {
        if(this.templateType === 'fbcomment') return 'Commented on your page';
        else if(this.templateType === 'externallinkopened') return 'Opened a link';
      } return '';
    },
    attachmentPreviewURL() {
      return this.message?.template?.attachment_preview_url;
    },
    currency() {
      return this.user.currency;
    },
    jsonMessage() {
      return this.message?.render_as === 'json' ? JSON.parse(this.message?.message) : null;
    },
  },
  methods: {
    renderNormalChat,
    genericSanitizeHtml,
    checkIfThereIsNoLogoThenShowTransparentImage,
    checkIfMessageNeedsBindHtml(input) {
      if(!input || input === 'None') return;
      input = input.replace(/</g, '&lt;').replace(/>/g, '&gt;');
      input = input.replace(/:::::/g, "<br> ").replace(/(?:\r\n|\r|\n)/g, '<br> ');

      return input.includes('http://') || input.includes('https://') || input.includes('<br');
    },
    convertCommaToLineBreak(input) {
      if(!input || input === 'None') return;
      return input.replace(/,/g, "<br/>");
    },
    isValidButton(button) {
      return button && Object.keys(button).length > 0;
    },
    checkExtraInfoProperties(val) {
      return typeof val === 'string' ? val.toLowerCase() : '';
    },
    isUrl(string) {
      try {
        new URL(string);
        return true;
      } catch (_) {
        return false;
      }
    },
    extractFileName(url) {
      try {
        return decodeURIComponent(url.split('/').pop().split('?')[0]);
      } catch (error) {
        return 'Document';
      }
    },
    getVideoMimeType,
    isBrowserPlayableVideoUrl,
    sanitizeHardLinkUrl,
    getLatLongFromTheGoogleMapsUrl,
  }
}
</script>
<style scoped lang="scss">
.normalchat_component{
  position: relative;
  display: inline-block;
  width: auto;
  max-width: 300px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  padding: 14px 10px;
  background-color: var(--purple);
  color: var(--white);
  font-weight: 400;
  font-size: 14px;
  line-height: 1.4;

}

.normalchat_component a,
.normalchat_component a:hover,
.normalchat_component a:active,
.normalchat_component a:focus{
  color: var(--purple);
  text-decoration: underline;
}

.botMsgBubble .normalchat_component a,
.botMsgBubble .normalchat_component a:hover,
.botMsgBubble .normalchat_component a:active,
.botMsgBubble .normalchat_component a:focus{
  color: var(--purple);
  text-decoration: underline;
}
.botMsgBubble .normalchat_component{
  background-color: #fff;
  color: #000;
}
.textDecoration{
  text-decoration: underline;
}
.paddingBottom{
  padding-bottom: 8px;
}
.noteMessageType{
  background-color: #EDDEFF !important;
}
.scheduleMessageType{
  background-color: var(--orange) !important;
}
.statusInfo{
  background-color: var(--purple-opac);
  color: var(--black);
  text-align: left;
}
.status-title{
  font-size: 14px;
  font-weight: 400;
  color: var(--purple);
  line-height: 16px;
}
.greenText{
  color: var(--green);
}
.reminderIcon{
  position: absolute;
  top: 0px;
  left: -20px;
  height: 30px;
  width: 30px;
  text-align: center;
  background-color: #ffffff;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: 0 0px 4px rgba(0,0,0,.08);
  box-shadow: 0 0px 4px rgba(0,0,0,.08);
}
.sub-header{
  font-size: 14px;
  font-weight: 400;
  line-height: 16px;
  color: var(--white);
}

.replytomessage_container{
  width: auto;
  max-width: 300px;
}

.replytomessage_container .innerDiv{
  position: relative;
  display: block;
  width: 100%;
  border: 1px #e4e6eb solid;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  overflow: hidden;
}

.replytomessage_container .innerDiv .sourceMessage{
  border-color: var(--ion-color-primary);
}

.replytomessage_container .innerDiv .sourceMessage.textType{
  padding: 8px;
  background-color: var(--gray-01);
}

.replytomessage_container .innerDiv .replyMessage.textType{
  padding: 8px;
  background-color: var(--white);
}

.replytomessage_container .innerDiv .sourceMessage.imageType,
.replytomessage_container .innerDiv .sourceMessage.videoType{
  font-size: 0px;
}

.replytomessage_container .innerDiv .replyMessage.imageType,
.replytomessage_container .innerDiv .replyMessage.videoType{
  font-size: 0px;
}

.replytomessage_container .imageInChat,
.replytomessage_container .videoInChat{
  width: 100%;
  display: block;
}
.audioInChat{
  width: 100%;
  display: block;
}
.videoFallback {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  background: var(--gray-04);
  border-radius: 10px;
  text-align: center;
  width: 240px;
  max-width: 100%;
}
.videoFallback .sub-title{
  color: var(--white);
  font-size: 14px;
  font-weight: 400;
}

.image_component{
  position: relative;
  display: inline-block;
  width: auto;
  max-width: 240px;
  height: auto;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  border: 1px #e4e6eb solid;
  overflow: hidden;
  font-size: 0;
}

.image_component .imageInChat{
  max-width: 100%;
  max-height: 300px;
  width: auto;
  height: auto;
}

.displayContainer {
  font-size: 13px;
  line-height: 1.3;
  text-decoration: underline;
  margin-bottom: 5px;
  display: block;
}
.mapContainer {
  border:0;
  height: 200px;
  width: 300px;
  max-width: 100%;
  -webkit-border-radius: 5px;
  border-radius: 5px; 
  overflow: hidden;
}

.buttonMessage_component{
  position: relative;
  display: inline-block;
  width: 330px;
  max-width: 100%;
  padding: 15px 0px 0px 0px;
  -webkit-border-radius: 10px;
  border-radius: 10px;
  border: 1px #e4e6eb solid;
  overflow: hidden;
  background-color: #fff;
}
.voiceTableArea{
  padding: 0px 10px 10px 10px;
}
table{
  margin: 0px;
  width: 100%;
}
.voiceTableArea th{
  color: var(--black);
  font-weight: 700;
  font-size: 12px;
  padding: 10px;
}
.voiceTableArea td{ 
  padding: 10px;
  font-size: 14px;
  color: var(--black);
  font-weight: 400;
  text-transform: none;
}
.voiceTableArea td, th {
  border: 1px solid var(--gray-04);
  text-align: left !important;
}
.openDocument, .reply_url{
  color: #ffffff !important;
}
.videoFallback .openDocument,
.videoFallbackLink {
  color: var(--white) !important;
  text-decoration: underline;
  font-size: 14px;
}
.audio_component {
  position: relative;
  width: auto;
  max-width: 300px;
}
.card {
  display: flex;
  background-color: var(--white);
  overflow: hidden;
  height: 100%;
  position: relative;
}
.rcs-rich-card {
  width: 100%;
  max-width: 450px;
  overflow: hidden;
  border-radius: 0px 5px 5px 0px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.rcs-rich-card.rightRichCard {
    .card {
      flex-direction: row-reverse;
    }
    .card-image img,
    .card-image video {
      border-radius: 0px 5px 5px 0px;
    }
    .button-container{
      border-radius: 0 0px 0px 5px;
    }
     /* Removed button-container border-radius here, apply it below if needed */
}
.card-image {
  width: 38%;
  background-size: cover;
  background-position: center;
  display: flex;
}
.card-image img,
.card-image video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px 0px 0px 5px;
  display: block;
}
.rcs-card-content {
  width: 62%;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}
.content-wrapper {
  padding: 10px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}
.card-header {
  margin-bottom: 10px;
  width: 100%;
  flex-shrink: 0;
}
.headerTitle {
  font-weight: 600;
  font-size: 16px;
  width: 100%;
  margin: 0;
}
.button-container {
  width: 100%;
  border-top: 1px solid var(--background-primary);
  background-color: var(--white);
  flex-shrink: 0;
}
.richCardButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px 24px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  color: var(--black);
}
.richCardButton:hover {
  background-color: #f5f5f5;
}
.richCardButton .title {
  width: 100%;
  text-align: center;
  margin: 0;
}
.richCardButton + .richCardButton {
  border-top: 1px solid var(--background-primary);
}
.flex-center{
  display: flex;
  align-items: center;
}
.document-preview {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  border-radius: 8px;
}
.document-img{
  height: auto !important;
}
.footerPadding{
  padding: 0px 10px 5px 10px;
}
.ml-auto{
  margin-left: auto;
}
.media-header{
  font-size: 16px;
  color: var(--black);
  font-weight: 700;
  padding: 10px 15px 0px 15px;
  text-align: left;
  max-width: 440px;
}
@media only screen and (max-width: 768px) { 
  .buttonMessage_component{
    width: 100%;
  }
}
.gap4P{
  gap: 4px;
}
.badge-light {
  display: inline-block;
  background: var(--background-primary);
  color: var(--black);
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 6px;
}
.contact-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 5px;
}
.contact-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
}
.contact-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.contact-info h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}
.contact-info p {
  margin: 2px 0 0;
  font-size: 12px;
  color: var(--gray-04);
}

/* Attachment Preview Integration Styles */
.image_component {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px 0;
}

.image_component .attachment-preview-wrapper {
  width: 100%;
}

.normalchat_component.customer_reply .attachment-preview-wrapper {
  width: 100%;
  margin: 0;
}

/* Responsive adjustments for chat preview */
@media only screen and (max-width: 600px) {
  .image_component {
    margin: 4px 0;
  }
}
</style>